<template>
    <div class="content-with-movie">
      <div class="col">
        <div v-if="status">
          <iframe style="width: 90%; height: auto;" :data-src="movieUrl" class="lazyload" title="(Youtube) Video" rel="preconnect" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div class="col" v-html="content"></div>
    </div>
</template>

<script>
export default {
  name: 'Col2WithMovie',

  data: function () {
    return {
    }
  },

  props: {
    movieUrl: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    },
    status: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style>
.btn {
  height: 1rem;
  padding: 4px 15px 22px 15px;
}

.call-to-action-btn {
  font-size: 15px;
  background-color: rgba(206, 94, 49, 0.5);
  color: #fff;
  border-radius: 20px;
  width: auto;
}

.content-with-movie {
  display: flex;
  flex: column;
  flex-wrap: wrap;
}

.content-with-movie .col:nth-child(1) {
  justify-content: space-around;
  order: 1;
  flex-grow: 1;
  flex-wrap: wrap;
}

.content-with-movie .col:nth-child(2) {
  justify-content: space-around;
  order: 2;
  flex-grow: 2;
  flex-wrap: wrap;
}

.content-with-movie .col ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

.content-with-movie .col li {
  color: #000;
  font-size: 15px;
  display: table-row;
}

.content-with-movie .col li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .content-with-movie .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 20px;
    margin-right: 20px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .content-with-movie .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 20px;
    margin-right: 20px;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content-with-movie .col:nth-child(1) {
    flex-basis: 100%;
    margin-left: 20px;
    margin-right: 20px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content-with-movie .col:nth-child(1) {
    flex-basis: 40%;
    margin-left: 20px;
    margin-right: 20px;
  }

  .content-with-movie .col:nth-child(2) {
    flex-basis: 50%;
    margin-right: 20px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content-with-movie .col:nth-child(1) {
    flex-basis: 375px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .content-with-movie .col:nth-child(2) {
    flex-basis: 52%;
  }
}
</style>
